export const HTML_COMPONENT_NAME = 'Html';
